import {getToken} from '../utils/auth'
export default function auth({next, store }) {
  
    if(!getToken()) {        
        return next({
            name:'login'
        })
    }
    return next()
}